import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { cvManagementApi } from '../../../services/api/cvManagementApi';

const CertificationIssuerFilter = ({ value, onChange, disabled = false }) => {
  const [issuers, setIssuers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchIssuers = async () => {
      try {
        setLoading(true);
        const data = await cvManagementApi.getGeneralCertificationIssuers();
        setIssuers(data || []);
      } catch (error) {
        console.error('Error fetching certification issuers:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchIssuers();
  }, []);

  const selectedIssuer = issuers.find(issuer => issuer.id === value) || null;

  return (
    <Autocomplete
      options={issuers}
      getOptionLabel={(option) => option.name || ''}
      value={selectedIssuer}
      onChange={(_, newValue) => onChange(newValue?.id || '')}
      loading={loading}
      disabled={disabled}
      size="small"
      sx={{ minWidth: 200 }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Issuer"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={16} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default CertificationIssuerFilter;
